import { IntegrationPageTemplate } from '@/components/IntegrationPageTemplate'
import { getIntegration } from '@/data/integrations'

export default function GoogleCalendarIntegrationPage() {
  return <IntegrationPageTemplate integration={getIntegration('google-calendar')} />
}
